import axiosInstance from './';
import Storage from '../helpers/storage';

export default class {
  constructor() {
    this.instance = axiosInstance();
  }

  getAll = () =>
    this.instance({
      url: `/products?merchantId=${Storage.getLocalStorageMerchant().idUnity}`,
      method: 'GET',
    });

  getAllByStatus = (status, extended = false) =>
    this.instance({
      url: `/products?status=${status}&merchantId=${Storage.getLocalStorageMerchant().idUnity}${
        extended ? `&style=extended` : ''
      }`,
      method: 'GET',
    });

  get = (offset, limit) =>
    this.instance({
      method: 'GET',
      url: `/products?limit=${limit}&offset=${offset}&merchantId=${
        Storage.getLocalStorageMerchant().idUnity
      }`,
    });

  getById = id =>
    this.instance({
      url: `/products/${id}`,
      method: 'GET',
    });

  put = (id, data) =>
    this.instance({
      url: `/products/${id}`,
      method: 'PUT',
      data,
    });

  patch = (id, data) =>
    this.instance({
      url: `/products/patch/${id}`,
      method: 'PUT',
      data,
    });

  save = data =>
    this.instance({
      url: `/products`,
      method: 'POST',
      data,
    });

  delete = products =>
    this.instance({
      url: `/products`,
      method: 'DELETE',
      data: products,
    });

  sortOrder = product => {
    const data = {
      sortOrder: product.sortOrder,
      categories: [{ id: product.idCategory }],
    };
    return this.instance({
      url: `/products/patch/${product.id}/sortOrder`,
      method: 'PUT',
      data,
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/Products.js